import AbilityScoreDiceManager from "./AbilityScoreDiceManager";

export { AbilityScoreDiceManager };

export default AbilityScoreDiceManager;
